"use client";

import { ReactNode } from 'react';

interface LayoutProps {
    onClose: () => void
    isSidebarOpen: boolean,
    children: ReactNode
}

export default function LayoutRight({ children }: LayoutProps) {

    return (        
       <div
            className="fixed top-0 border-l border-white/20 shadow-2xl z-35 transition-all duration-300 rounded-[20px] overflow-hidden scrollbar-hide bg-white"
            style={{
                right: `30px`,
                width: `400px`,
                height: `calc(100dvh - 200px)`, // 64px for header height
                top: '50%',
                transform: 'translateY(-50%)',
                scrollbarWidth: 'none', /* Firefox */
                msOverflowStyle: 'none', /* Internet Explorer 10+ */
                overflow:'scroll'
            }}
        >
            {children}
        </div>
    )
}
